import { SliderContainerType } from "./SliderContainer";
import Title from "../LoanTermDeviation/Title";

import { formatAndMaskMobile } from "./utils";
import { useUtilityStates } from "./useStates";

export default function Success(props: SliderContainerType) {
  const { close } = props;
  const { selectedOffer } = useUtilityStates((state) => state);

  return (
    <div className="p-10 relative">
      <Title
        title=""
        close={close}
      />
      <div className="flex justify-center mt-10">
        <div className="max-w-md text-center">
          <div className="flex justify-center">
            <img
              alt="success"
              className="w-44	h-48"
              src="/lunch-success.png"
            />
          </div>
          <div className="text-[#373737] text-2xl font-medium mt-12">
            Offer Link sent succesfully!
          </div>
          <div className="text-[#4C4C4D] text-lg font-medium mt-5">
            The Session link has been sent to the user on{" "}
            {formatAndMaskMobile(selectedOffer?.mobile)}
          </div>
          <div className="text-[#8D8D8E] text-sm font-medium mt-3">
            The user will need to finish the journey on the link to get the
            disbursal
          </div>
        </div>
      </div>
    </div>
  );
}
